import StorageException from '../exception/StorageException'
import StorageKeysConfig from '../StorageKeysConfig'

const StorageKeysConfigMap = {}
for (const item of Object.values(StorageKeysConfig)) {
  StorageKeysConfigMap[item.Key] = item.EntityClass
}

export const checkType = (key, value) => {
  if (!StorageKeysConfigMap[key]) {
    console.error(-1, `storage entity is not matched: key = '${key}', value = '${JSON.stringify(value)}'`)
  }
}
